/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDRadiusUpLeftIcon20Light = forwardRef('ArrowDRadiusUpLeftIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M7.146 2.646a.5.5 0 1 1 .708.708L3.207 8H10.5a7.5 7.5 0 0 1 7.5 7.5v1a.5.5 0 1 1-1 0v-1A6.5 6.5 0 0 0 10.5 9H3.207l4.647 4.646a.5.5 0 0 1-.708.708L2.495 9.702a1.7 1.7 0 0 1 0-2.404l4.651-4.652Z" })));
});
